<template>
  <modal
    :open="isOpen"
    :title="modalTitle"
    :saveText="modalSaveText"
    @save="submit"
    @cancel="cancel"
  >
    <div class="user-invite">
      <field
        :required="true"
        :errors="errors"
        type="email"
        name="email"
        model="user"
        v-model="item.email"
      />
      <field
        :required="true"
        :errors="errors"
        model="user"
        name="role"
        type="radio"
        v-model="item.role"
        :collection="roles"
        :defaultValue="'user'"
      />
      <field
        :required="false"
        :errors="errors"
        model="user"
        v-can="'organizations.list'"
        name="organization"
        v-model="item.organization"
        type="select"
        :params="{no_i18n: true}"
        :collection="organizations"
      />
    </div>
  </modal>
</template>
<script>
import Field from '@/components/helpers/DataInput/Field';
import User from '@/api/User';
import OrganizationApi from '@/api/Organization'
import { EventBus } from '@/EventBus.js';
import Permission from '@/classes/Permission'
import Modal from '@/components/helpers/Layout/NewModal'

export default{
  props: {
    id: {},
  },
  components: {
    Field,
    Modal
  },
  data(){
    return{
      isOpen: false,
      errors: [],
      item: {},
      organizations: [],
      roles: [{name: 'user', value: 'user'}, {name: 'admin', value: 'admin'}]
    }
  },
  computed: {
    modalTitle() {
      return this.$t('ui.users.invite')
    },
    modalSaveText() {
      return this.$t('ui.button.users.invite')
    }
  },
  mounted(){
    this.item.status = "confirmed"
    this.retrieve_associations()
    EventBus.$on('action', this.handleAction);
  },
  methods: {
    async submit(){
      this.errors = []
      let user = new User()
      if (this.item.lastname == undefined) { this.item.lastname = " " }
      if (this.item.firstname == undefined) { this.item.firstname = " " }
      // the API needs the organization_id param so setting this here
      if ((this.item.organization_id == undefined) && (this.item.organization)) { this.item.organization_id = this.item.organization }
      try {
        let response = await user.invite(this.item,this.$i18n.locale)
        this.item   = {}
        this.isOpen = false
        this.handleSuccess(response)
      } catch (err) {
        this.errors = err.response.data.errors
      }
    },
    handleSuccess(user) {
      this.$store.commit('SET_NOTIFICATION', {
        'title': this.$t('models.user.message.create'),
        'type': 'success'
      })
      this.$emit('user_invited', user)
    },
    handleAction(action){
      this.isOpen = action == "users.invite"
    },
    cancel(){
      this.isOpen = false
    },
    retrieve_associations(){
      let permission = Permission.loadPermissions()

      if(Permission.can(permission, 'organizations.list')){
        let api = new OrganizationApi()
        api.all_for_association().then((items) => {
          this.organizations = items
        }).catch(function(error) {
          console.log(error)
        })
      }
    },
  }
}
</script>
<style lang="scss">
.user-invite{
  .validation-message{
    margin-top: 5px;
  }
.input--select-wrapper:after {
    height: 34px;
    line-height: 34px;
    top: 0px;
}
  h4{
    font-size: 18px;
    margin-top: 0;
  }
  .field{
    margin-top: 0;
  }
  .field--input{
    margin-bottom: 0;
    font-size: 14px;
    width: 100%;
  }
  .input--select {
    height: 30px;
  }
  .user-invite--grid{
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .user-invite--firstname{
    flex-grow: 5;
    margin-bottom: 10px;
  }
  .user-invite--lastname{
    flex-grow: 5;
    margin-bottom: 10px;
  }
  .user-invite--email{
    flex-grow: 6;
    margin-bottom: 20px;
  }
  .user-invite--role {
    flex-grow: 6;
    margin-bottom: 10px;
  }
  .user-invite--submit{
    flex-grow: 0;
    .btn {
      width: 100%;
      font-weight: 400;
    }
  }
}
</style>



// WEBPACK FOOTER //
// UserInvite.vue?2dd1cc9c